import React, {useState, createContext} from 'react';

export const UserContext = createContext();

export const UserProvider = props => {
	const currentUser = JSON.parse(localStorage.getItem('user'));
	const initiateUser = currentUser ? currentUser : null;
	const [ user, setUser ] = useState(initiateUser);
	const [ collapsed, setCollapsed ] = useState(false);

	const [ movies, setMovies ] = useState([]);
	const [ fetchMovies, setFetchMovies ] = useState(true);
	const [ curIdMovies, setCurIdMovies ] = useState(null); 

	const [ games, setGames ] = useState([]);
	const [ fetchGames, setFetchGames ] = useState(true);
	const [ curIdGames, setCurIdGames ] = useState(null); 

	const [ showFilteredItems, setShowFilteredItems ] = useState(false)
	const [ headCells, setHeadCells ] = React.useState([
    { id: 'name', align: 'left', disablePadding: true, label: 'Name', isSorted: true, isVisible: true },
    { id: 'image', align: 'center', disablePadding: false, label: 'Image', isSorted: false, isVisible: true },
    { id: 'genre', align: 'left', disablePadding: false, label: 'Genre', isSorted: true, isVisible: true },
    { id: 'release', align: 'right', disablePadding: true, label: 'Release', isSorted: true, isVisible: true },
    { id: 'platform', align: 'left', disablePadding: false, label: 'Platform', isSorted: true, isVisible: true },
    { id: 'mode', align: 'left', disablePadding: false, label: 'Mode', isSorted: false, isVisible: true },
    { id: 'action', align: 'center', disablePadding: false, label: 'Action', isSorted: false, isVisible: true }
  ]);

	const [ showFilteredItems2, setShowFilteredItems2 ] = useState(false)
	const [ headCells2, setHeadCells2 ] = React.useState([
    { id: 'title', align: 'left', disablePadding: true, label: 'Title', isSorted: true, isVisible: true },
    { id: 'image', align: 'center', disablePadding: false, label: 'Image', isSorted: false, isVisible: true },
    { id: 'genre', align: 'left', disablePadding: false, label: 'Genre', isSorted: true, isVisible: true },
    { id: 'rating', align: 'right', disablePadding: false, label: 'Rating', isSorted: true, isVisible: true },
		{ id: 'year', align: 'right', disablePadding: true, label: 'Year', isSorted: true, isVisible: true },
    { id: 'duration', align: 'right', disablePadding: false, label: 'Duration', isSorted: true, isVisible: true },
		{ id: 'description', align: 'left', disablePadding: false, label: 'Description', isSorted: false, isVisible: true },
		{ id: 'review', align: 'left', disablePadding: false, label: 'Review', isSorted: false, isVisible: true },
    { id: 'action', align: 'center', disablePadding: false, label: 'Action', isSorted: false, isVisible: true }
  ]);

	const [ pathName, setPathName ] = React.useState(window.location.pathname);
	// Drwaer
	const [ open, setOpen ] = React.useState(false);
	
	return(
		<UserContext.Provider value={{ 
			user, 
			setUser, 
			collapsed, 
			setCollapsed, 
			movies, 
			setMovies,
			fetchMovies,
			setFetchMovies,
			curIdMovies,
			setCurIdMovies,
			games,
			setGames,
			fetchGames,
			setFetchGames,
			curIdGames,
			setCurIdGames,
			showFilteredItems, 
			setShowFilteredItems,
			headCells, 
			setHeadCells,
			showFilteredItems2, 
			setShowFilteredItems2,
			headCells2, 
			setHeadCells2,
			pathName, 
			setPathName,
			open, 
			setOpen
		}}>
			{props.children}
		</UserContext.Provider>
	)
}